export const PROJECTS = [
  {
    id: 1,
    title: "9Z Team Page",
    img: "https://raw.githubusercontent.com/bredigian/proyecto_9z/main/img/9z.webp",
    description_es: "Pagina web con toda la informacion acerca de 9Z Team.",
    description_en: "Web page with all the information about 9Z Team.",
    link: "https://ninezteam.netlify.app/",
  },
  {
    id: 2,
    title: "CasaTomada Shop",
    img: "https://raw.githubusercontent.com/bredigian/appCasaTomada/main/assets/img/logo/logoCasatomada.png",
    description_es: "Tienda online de CasaTomada.",
    description_en: "Online store of CasaTomada.",
    link: "https://casatomada.netlify.app/",
  },
  {
    id: 3,
    title: "brg's Shop",
    img: "https://camo.githubusercontent.com/607a4b62798239b23cda9bbb5a29becbc362f16e779c0e91aaa0059f5f42ca9f/68747470733a2f2f692e6962622e636f2f5a63667a6232732f62726749636f6e2e706e67",
    description_es:
      "Tienda online de comercio ficticio de perifericos gamers de computadora.",
    description_en: "Online store of fictitious computer gaming peripherals.",
    link: "https://brgshop.netlify.app/",
  },
  {
    id: 4,
    title: "CasaTomada App",
    img: "https://raw.githubusercontent.com/bredigian/appCasaTomada/main/assets/img/logo/logoCasatomada.png",
    description_es:
      "Aplicacion movil de CasaTomada para Android y IOS, realizdo con React Native.",
    description_en:
      "Mobile application of CasaTomada for Android and IOS, made with React Native.",
    link: "https://expo.dev/@bredigian/appCasatomada",
  },
]
